import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Grafica from '../../components/estadistica/Grafica'
import Layout from '../../components/layout/Layout'
import { Subjects } from '../../helpers/consultas'

const EstadisticasView = () => {
    const {email} = useSelector(state => state.perfil);
    const [likes, setLikes] = useState();
    const [namesSubjects, setNamesSubjects] = useState();
    const [students, setStudents] = useState();

    useEffect(() => {
        Subjects(email)
        .then(data => {
            setNamesSubjects(data.nameAsig)
            setStudents(data.students)
            setLikes(data.likes)
        })
        return () => { }
    }, [ email ])

    return (
        <Layout>
            <div className='container-grid-estadisticas'>
                <div className='item__grid__estadisticas'>
                       <Grafica 
                            nameAsig={namesSubjects}
                            label='Likes por Asignatura'
                            title='Likes por Asignatura'
                            data={likes}
                            type='Pie'
                        />
                </div>
                <div className='item__grid__estadisticas'>
                        <Grafica 
                            nameAsig={namesSubjects}
                            label='Numero de Estudiantes'
                            title='Estudiantes por Asignatura'
                            data={students}
                            type='Polar'
                        />
                </div>
                {/* <div className='item__grid__estadisticas'>
                        <Grafica 
                            nameAsig={namesSubjects}
                            label='Numero de Estudiantes'
                            title='Cantidad de estudiantes por Asignatura'
                            data={students}
                            type='Bar'
                        />
                </div> */}
            </div>
        </Layout>
    )
}

export default EstadisticasView
